import type { ProductData } from '@Types/Product';

const rearrangeProductsGroup = (group: ProductData[][]) => {
  const maxLength = Math.max(...group.map((products) => products?.length || 0));
  const result: ProductData[] = [];

  for (let i = 0; i < maxLength; i += 1) {
    for (let j = 0; j < group.length; j += 1) {
      if (group[j][i]) {
        result.push(group[j][i]);
      }
    }
  }

  return result;
};

export default rearrangeProductsGroup;
